export const borrarObjLocal = ({key}) => {


    window.localStorage.removeItem(key)


}